/* kg und kg_h ist 0
 * kwh und kwh_h ist 1
 * */
export enum UnitTypeForBackendEnum {
  KG = 0,
  KG_H = 0,
  KWH = 1,
  KWH_H = 1,
}
